import React from 'react';
import { Box, Typography, Container } from '@mui/material';

interface AboutUsProps {
  sectionRef: React.RefObject<HTMLDivElement | null>;
}

const AboutUs: React.FC<AboutUsProps> = ({sectionRef}) => {
  return (
    <Container maxWidth="lg">
      <Box ref={sectionRef} sx={{ py: 8 }}>
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', md: 'row' },
          gap: 4
        }}>
          <Box sx={{
                p: 4,
                borderRadius: 2,
                background: 'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(0,0,80,0.2)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-5px)',
                  background: 'rgba(0,0,80,0.15)',
                },
              }}>
            <Typography variant="h4" component="h2" gutterBottom>
              About Preciora
            </Typography>
            <Typography variant="body1" paragraph>
              Preciora is a leading software solutions provider, dedicated to delivering innovative and efficient solutions for businesses worldwide. Our team of experts combines technical expertise with industry knowledge to create tailored solutions that drive growth and success.
            </Typography>
          </Box>
          <Box sx={{
                p: 4,
                borderRadius: 2,
                background: 'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(0,0,80,0.2)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-5px)',
                  background: 'rgba(0,0,80,0.15)',
                },
              }}>
            <Typography variant="h4" component="h2" gutterBottom>
              Our Mission
            </Typography>
            <Typography variant="body1" paragraph>
              Our mission is to empower businesses with cutting-edge software solutions that streamline operations, enhance productivity, and drive innovation. We believe in creating sustainable, scalable, and user-friendly solutions that make a real difference.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default AboutUs; 